<template>
  <el-container class="container1300 is-vertical no-shrink">
    <!-- <h1 class="heading">Featured tours</h1> -->
    <div class="container800">
      <div class="featured-carousel-cnt">
        <el-carousel class="featured-carousel" :interval="5000" trigger="click" :type="sliderType"
                     v-if="featured.length">
          <el-carousel-item v-for="item in featured" :key="item.id">
            <library-item :item="item" :min="true"/>
          </el-carousel-item>
        </el-carousel>
      <!-- <div class="library-items">
        <el-row v-masonry transition-duration="0s" item-selector=".masonry-item" class="masonry-container" el-row
                type="flex" :gutter="6" justify="center" :width="{'100%': true}">
          <el-col v-masonry-tile class="masonry-item" :class="{animate: i>=16}"
                  v-for="item,i in featured" :key="item._id" :xs="12" :sm="12" :md="12" :lg="6"
                  :xl="6">
            <library-item :item="item"/>
          </el-col>
        </el-row>
      </div> -->
      </div>
    </div>
    <div class="flex-center no-shrink"><h2 style="
    color: #fff;
    font-size: 40px;
    margin: 65px 10px 0;
">Coobo Overview</h2></div>
<div class="text-content">
<div class="flex-center no-shrink">
  <p>Our mission is simple, <br/>To deliver the most engaging, authentic STEAM content to students with as little hassle as possible.</p>
</div>
<div class="flex-center no-shrink">
  <p>Coobo is a 3D interactive online creation platform.</p>
</div>
<div class="flex-center no-shrink">
  <p>We tell these stories through beautiful visuals.</p>
</div>
<div class="flex-center no-shrink">
  <iframe src="https://player.vimeo.com/video/326276712" width="800" height="450" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
</div>
</div>
  </el-container>
</template>

<script>
  import LibraryItem from "../components/library-item.vue"
  // import LibraryItems from "../components/library-items.vue"

  export default {
    name: 'Home',
    components: {
      LibraryItem
    },
    data () {
      return {
        categories: [],
        featured: [
          {title: "Lungs",
            url: "https://coobo.azureedge.net/5e563ad3a29cee001acb4c81.html",
            thumbUrl: "https://coobo.azureedge.net/5e563ad3a29cee001acb4c81/BF833B23-425D-414B-A2CE-44598D64A955.jpg.webp"
          },
          {title: "Graphite",
            url: "https://coobo.azureedge.net/5e56cd1cf6181c4375affe26.html",
            thumbUrl: "https://coobo.azureedge.net/5e56cd1cf6181c4375affe26/936107D9-86FA-4BC4-898E-E23957C5E751.jpg.webp"
          },
          {title: "Concave Mirror",
            url: "https://coobo.azureedge.net/5e706c47406a179c6f474282.html",
            thumbUrl: "https://coobo.azureedge.net/5e706c47406a179c6f474282/4DBD4107-C508-4B64-A15E-DA53366AD82C.jpg.webp"
          },
          {title: "Impossible Event",
            url: "https://coobo.azureedge.net/5e6234d15d2e42122ef8f776.html",
            thumbUrl: "https://coobo.azureedge.net/5e6234d15d2e42122ef8f776/EC1EFA86-CBC8-4E15-AB49-7106E038FF63.jpg.webp"
          }
        ],
        sliderType: "card",
      }
    },
    mounted: function () {
      window.addEventListener("resize", this.onResize);
      this.onResize();
      this.axios.get(this.$store.state.API_URL + "demo?featured=1&public=1")
        .then((res) => {
          // this.featured = res.data;
        });
    },
    methods: {
      onResize() {
        if (window.innerWidth >= 768) {
          this.sliderType = "card";
        } else {
          this.sliderType = "";
        }
      },
    },
    destroyed: function() {
      window.removeEventListener("resize", this.onResize)
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue